import { FC } from 'react';
import { useLocation } from 'react-router';

import ListItemIcon from '@mui/material/ListItemIcon';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import FlightIcon from '@mui/icons-material/Flight';
import HotelIcon from '@mui/icons-material/Hotel';
import PeopleIcon from '@mui/icons-material/People';
import ConstructionIcon from '@mui/icons-material/Construction';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import DescriptionIcon from '@mui/icons-material/Description';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Link from '@mui/material/Link';
import Drawer from 'components/Drawer';

import logo from 'assets/tedo-logo-blue.png';

type Props = {
  open: boolean;
  onToggle: () => void;
};

const selected = (path: string, pathname: string) => pathname.startsWith(path);

const MainMenu: FC<Props> = ({ open, onToggle }) => {
  const { pathname } = useLocation();

  return (
    <Drawer variant="permanent" open={open}>
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          px: [1],
        }}>
        <Box sx={{ flexGrow: 1, pt: 1, pl: 1 }}>
          <img src={logo} alt="Tedo.lt Admin" />
        </Box>

        <IconButton onClick={onToggle}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>

      <Divider />

      <List>
        <ListItemButton href="/" component={Link} selected={pathname === '/'}>
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>

          <ListItemText primary="Dashboard" />
        </ListItemButton>

        <Divider />

        <ListItemButton
          href="orders"
          component={Link}
          selected={selected('/orders', pathname)}>
          <ListItemIcon>
            <ShoppingCartIcon />
          </ListItemIcon>

          <ListItemText primary="Užsakymai" />
        </ListItemButton>

        <ListItemButton
          href="packages"
          component={Link}
          selected={selected('/packages', pathname)}>
          <ListItemIcon>
            <BeachAccessIcon />
          </ListItemIcon>

          <ListItemText primary="Pasiūlymai" />
        </ListItemButton>

        <ListItemButton
          href="flights"
          component={Link}
          selected={selected('/flights', pathname)}>
          <ListItemIcon>
            <FlightIcon />
          </ListItemIcon>

          <ListItemText primary="Skrydžiai" />
        </ListItemButton>

        <ListItemButton
          href="hotels"
          component={Link}
          selected={selected('/hotels', pathname)}>
          <ListItemIcon>
            <HotelIcon />
          </ListItemIcon>

          <ListItemText primary="Viešbučiai" />
        </ListItemButton>

        <Divider />

        <ListItemButton
          href="content"
          component={Link}
          selected={selected('/content', pathname)}>
          <ListItemIcon>
            <DescriptionIcon />
          </ListItemIcon>

          <ListItemText primary="Turinys" />
        </ListItemButton>

        <ListItemButton
          href="seo"
          component={Link}
          selected={selected('/seo', pathname)}>
          <ListItemIcon>
            <SearchIcon />
          </ListItemIcon>

          <ListItemText primary="SEO" />
        </ListItemButton>

        <Divider />

        <ListItemButton
          href="users"
          component={Link}
          selected={selected('/users', pathname)}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>

          <ListItemText primary="Vartotojai" />
        </ListItemButton>

        <ListItemButton
          href="tools"
          component={Link}
          selected={selected('/tools', pathname)}>
          <ListItemIcon>
            <ConstructionIcon />
          </ListItemIcon>

          <ListItemText primary="Įrankiai" />
        </ListItemButton>

        <ListItemButton
          href="settings"
          component={Link}
          selected={selected('/settings', pathname)}>
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>

          <ListItemText primary="Nustatymai" />
        </ListItemButton>
      </List>
    </Drawer>
  );
};

export default MainMenu;
